import { getParamValue } from './handle-url.utils'
import { quoteModelTransform } from '../transforms/quoteModel.transform'

/**
 * Quote is in Garage
 * @param { Array } quotesInGarage - List of QuoteIds in garage.
 * @param { String } quoteId - QuoteId to check.
 */
export const isQuoteInGarage = (quotesInGarage, quoteId) => {
    if (!quotesInGarage || !Array.isArray(quotesInGarage) || !quoteId) return false

    return !!quotesInGarage.find(({ id }) => id === quoteId)
}

/**
 * User is Authenticated
 */
// export const isAuthenticated = window.CommonsGeneral.AccountService.isAuthenticated()

/**
 * Update Quote Information
 * @param { object } quoteDesking - Quote Desking with all infos.
 * @param { object } paymentOptions - Payment Options Object with all infos.
 */
export const updateQuote = async (quoteDesking, paymentOptions, vehicle) => {
    const { accountId, id, leadId, quoteRevision } = quoteDesking || {}

    const {
        cashDown,
        financePlan,
        kmPerYearPlan,
        lien,
        paymentFrequency,
        purchaseMethod,
        saleType,
        taxPlan,
        term,
        tradeIn,
        transactionToken,
        vehicleCondition,
    } = paymentOptions || {}

    const addToGarageV25 = new window.CommonsVehicle.Quote.AddToGarageV25()
    const updateQuoteModel = new window.CommonsVehicle.Quote.UpdateQuoteModelV25({
        accountId,
        cashDown,
        financePlan,
        kmPerYearPlan,
        id,
        leadId,
        lien,
        paymentFrequency,
        purchaseMethod,
        quoteRevision,
        saleType,
        taxPlan,
        term,
        tradeIn,
        transactionToken,
        vehicleCondition,
        vehicle,
    })

    return addToGarageV25.updateQuote(updateQuoteModel)
}

/**
 * Vehicle Add To Garage
 * @param { object } vehicleInfos - Vehicle Object with all infos.
 * @param { object } paymentOptions - Payment Options Object with all infos.
 * @param { string } category - Vehicle category - catalog or inventory (default: inventory)
 */
export const addToGarage = (vehicleInfos, paymentOptions, category = 'inventory') => {
    const quoteModel = quoteModelTransform(vehicleInfos, paymentOptions, category)

    const addToGarageV25 = new window.CommonsVehicle.Quote.AddToGarageV25()
    const saveNewQuoteModel = new window.CommonsVehicle.Quote.SaveNewQuoteModelV25(quoteModel)

    addToGarageV25.addToGarageOnClick(saveNewQuoteModel)
}

/**
 * Vehicle Go To Checkout
 * @param { object } vehicleInfos - Vehicle Object with all infos.
 * @param { object } paymentOptions - Payment Options Object with all infos.
 * @param { string } checkoutUrl - Checkout Url (pass url only if quote is in garage else pass an empty string)
 * @param { string } category - Vehicle category - catalog or inventory (default: inventory)
 */
export const goToCheckout = async (vehicleInfos, paymentOptions, checkoutUrl, category = 'inventory') => {
    if (checkoutUrl) {
        window.location.href = checkoutUrl
    } else {
        const quoteModel = quoteModelTransform(vehicleInfos, paymentOptions, category)
        const addToGarageV25 = new window.CommonsVehicle.Quote.AddToGarageV25()
        const saveNewQuoteModel = new window.CommonsVehicle.Quote.SaveNewQuoteModelV25(quoteModel)

        // Add vehicle to garage and Go to checkout
        addToGarageV25.buyOnlineOnClick(saveNewQuoteModel)
    }
}
